import React, { useState } from "react";
import { Navigate } from "react-router";
import Button from "@shared/v2/Button";
import TextComboInput from "@shared/v2/TextComboInput";
import TextLink from "@shared/v2/TextLink";
import { ArrowUpRightFromSquareSolidV6, MagnifyingGlassSolidV6, PlusSolidV6 } from "@shared/v2/Icomoon";
import WebsiteHeader from "../shared/WebsiteHeader";
import AboutWebsiteProfilesModal from "./AboutWebsiteProfilesModal";
import CollapsibleWebsiteCard from "../shared/CollapsibleWebsiteCard";
import { useFeatureFlags } from "../../reducers/layoutReducer/selectors";

const Roster = () => {
  const featureFlags = useFeatureFlags();
  const [showAboutModal, setShowAboutModal] = useState(false);

  if (!featureFlags.websiteRoster) return <Navigate to="/website" />;

  return (
    <div className="tw-flex-1 tw-max-w-[1416px] tw-mx-auto tw-flex tw-flex-col tw-gap-[16px] tw-p-[16px]">
      <div className="tw-relative tw-flex tw-flex-col tw-gap-[32px] tw-bg-white tw-border-[1px] tw-border-solid tw-border-gray-10 tw-rounded-[8px] tw-p-[32px] tw-overflow-auto">
        <WebsiteHeader
          title="Roster"
          description={
            <>
              Showcase your team on your Brivity website by adding agents, setting a preferred lender,
              customizing display order, and featuring key team members. <TextLink>Learn more</TextLink>.
            </>
          }
          actions={
            <>
              <TextComboInput
                containerClassName="tw-flex-1 tw-max-w-[280px] tw-w-[280px] tw-min-w-[200px]"
                placeholder="Search agents by name"
                trailing={<MagnifyingGlassSolidV6 size="l" className="tw-text-gray-30" />}
              />
              <Button
                size="medium"
                schema="tertiary"
                className="tw-whitespace-nowrap tw-flex tw-items-center tw-gap-[8px]"
              >
                View Team Page <ArrowUpRightFromSquareSolidV6 />
              </Button>
              <Button
                size="medium"
                className="tw-whitespace-nowrap tw-flex tw-items-center tw-gap-[8px]"
                onClick={() => setShowAboutModal(true)}
              >
                <PlusSolidV6 /> Add To Roster
              </Button>
            </>
          }
        />
        <AboutWebsiteProfilesModal show={showAboutModal} onClose={() => setShowAboutModal(false)} />
      </div>
      <div className="tw-flex tw-gap-[16px] tw-flex-wrap">
        <div className="tw-flex-1 tw-basis-1/2 tw-flex tw-flex-col tw-gap-[16px]">
          <CollapsibleWebsiteCard title="Featured Agents" />
          <CollapsibleWebsiteCard title="Our Team" allowCollapse={false} />
        </div>
        <div className="tw-basis-[300px]">
          <CollapsibleWebsiteCard title="Preferred Lender" allowCollapse={false} />
        </div>
      </div>
    </div>
  );
};

export default Roster;
